var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "new-se-dialog" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            width: "400px",
            title: "Add New HCP",
            visible: _vm.dialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            close: _vm.onClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "type", label: "Type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "Please select type",
                        disabled: _vm.disabledType,
                      },
                      on: { change: _vm.onTypeChange },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    _vm._l(_vm.typeList, function (item, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { value: item.TypeID, label: item.TypeDesc },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "mlId",
                    label: _vm.typeIsVCE || _vm.isVMSL ? "vMSL" : "MSL",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder:
                          _vm.typeIsVCE || _vm.isVMSL
                            ? "Please select MSL"
                            : "Please select vMSL",
                        disabled: _vm.isMSL || _vm.type == "here" || _vm.isVMSL,
                      },
                      on: { change: _vm.onMlChange },
                      model: {
                        value: _vm.form.mlId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mlId", $$v)
                        },
                        expression: "form.mlId",
                      },
                    },
                    _vm._l(_vm.mlList, function (item, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { value: item.value, label: item.label },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "name", label: "Name" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.disabled,
                      placeholder: "Please input name",
                      maxlength: "10",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm.type != "here"
                ? _c(
                    "el-form-item",
                    { attrs: { prop: "province", label: "Province" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: _vm.disabled && !_vm.provinceEmpty,
                            placeholder: "Please select province",
                          },
                          on: { change: _vm.provinceChange },
                          model: {
                            value: _vm.form.province,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "province", $$v)
                            },
                            expression: "form.province",
                          },
                        },
                        _vm._l(_vm.provinceList, function (item, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: {
                              label: item.province,
                              value: item.province,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { prop: "city", label: "City" } },
                [
                  _vm.type == "here"
                    ? _c("el-input", {
                        attrs: {
                          disabled: _vm.disabled && !_vm.cityEmpty,
                          placeholder: "Please input city",
                          maxlength: "25",
                        },
                        model: {
                          value: _vm.form.city,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "city", $$v)
                          },
                          expression: "form.city",
                        },
                      })
                    : _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: _vm.disabled && !_vm.cityEmpty,
                            placeholder: "Please select city",
                          },
                          on: { change: _vm.cityChange },
                          model: {
                            value: _vm.form.city,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "city", $$v)
                            },
                            expression: "form.city",
                          },
                        },
                        _vm._l(_vm.cityList, function (city, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { label: city, value: city },
                          })
                        }),
                        1
                      ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "hospital", label: "Hospital / Institution" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.disabled && !_vm.hospitalEmpty,
                      placeholder: "Please input hospital / institution",
                      maxlength: "25",
                    },
                    model: {
                      value: _vm.form.hospital,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hospital", $$v)
                      },
                      expression: "form.hospital",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "department", label: "Department" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.disabled && !_vm.departmentEmpty,
                      placeholder: "Please input department",
                      maxlength: "25",
                    },
                    model: {
                      value: _vm.form.department,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "department", $$v)
                      },
                      expression: "form.department",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tag" } },
                [
                  _c("hcp-tag-select", {
                    attrs: {
                      "bind-owner": "",
                      "owner-user-id": _vm.tagOwnerId,
                    },
                    model: {
                      value: _vm.form.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tags", $$v)
                      },
                      expression: "form.tags",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "phone", label: "Phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input phone",
                      maxlength: "20",
                    },
                    on: { input: _vm.onPhoneInput },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _vm.admin && _vm.type == "here"
                ? _c("p", { staticClass: "text" }, [
                    _vm._v("仅限创建Customer信息"),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v(" Submit" + _vm._s(_vm.loading ? "ting" : "") + " ")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }